module.exports = __webpack_public_path__ + "static/media/filter-icon-reset-pressed.c473528e.svg";